import i18n from '@api/i18n';
import { Recipient } from '@dev/ee-api/ee-api-models';

export const logsBounceMessage = (recipient: Recipient): string => {
    switch (recipient.MessageCategory) {
        case 'Unknown':
            return '';
        case 'BlackListed':
            return i18n.t('blacklisted');
        case 'Ignore':
            return i18n.t('ignore');
        case 'Spam':
            return i18n.t('spam');
        case 'NoMailbox':
            return i18n.t('nomailbox');
        case 'GreyListed':
            return i18n.t('greylisted');
        case 'Throttled':
            return i18n.t('throttledcategory');
        case 'Timeout':
            return i18n.t('timeoutdesc');
        case 'ConnectionProblem':
            return i18n.t('connectionproblem');
        case 'SPFProblem':
            return i18n.t('spfproblem');
        case 'AccountProblem':
            return i18n.t('accountproblem');
        case 'DNSProblem':
            return i18n.t('dnsproblem');
        case 'WhitelistingProblem':
            return i18n.t('whitelistingproblem');
        case 'CodeError':
            return i18n.t('codeerror');
        case 'ManualCancel':
            // if (recipient.Message?.startsWith('[User Cancelled]')) {
            //     return i18n.t('usercancelleddesc');
            // }
            return i18n.t('manualcancel');
        case 'ConnectionTerminated':
            return i18n.t('connectionterminated');
        case 'NotDeliveredCancelled':
            if (recipient.Message?.startsWith('[Content Filter]')) {
                return i18n.t('contentfilterdesc');
            }

            return i18n.t('notdeliveredcancelled');
        case 'NotDelivered':
            if (recipient.Message?.startsWith('[Blocked Recipient]')) {
                return i18n.t('blockedrecipientdesc');
            } else if (recipient.Message?.startsWith('[Global Blocked Recipient]')) {
                return i18n.t('globalblockedrecipientdesc');
            } else if (recipient.Message?.startsWith('[Spam Check]')) {
                return i18n.t('spamcheckdesc');
            } else if (recipient.Message?.startsWith('[Unsubscribe List]')) {
                return i18n.t('unsubscribedesc');
            }
            const otherMessage = {
                'Recipient on contact block list.': i18n.t('blockedrecipientdesc'),
                'Not enough credit.': i18n.t('notenoughcreditdesc'),
                'Not enough credit for attachments.': i18n.t('notenoughcreditforattachments'),
            };
            return otherMessage?.[recipient.Message] ?? i18n.t('notdelivered');
        default:
            return i18n.t('unknown');
    }
};
